import React from "react";

const NoPage = () => {
    return <div>Error: the page you are looking for does not exist.</div>;
};

export default NoPage;
